export enum EPropsToMap {
  TIPO_VEIC_LABEL = 'tipoVeicoloLabel',
  TIPO_VEIC_MCTC_LABEL = 'tipoVeicoloMCTCLabel',
  PROVENIENZA = 'provenienza',
  TIPO_IMMATR = 'tipoImmatricolazione',
  CODICE_CAUS = 'codiceCausale',
  TIPO_MOV = 'tipoMov',
  CODICE_CAUS_ACI = 'codiceCausaleACI',
  TIPO_DENOM = 'tipoDenominazione',
  COD_ALIMENTA = 'codAlimenta',
  CARROZZ_SPEC = 'carrozzeriaSpacializ',
  MOD_PAGAMENTO = 'modPagam',
  TARIFFA = 'tariffa',
  TIPO_POLIZZA = 'tipoPolizza',
  CANALE_AGG_LABEL = 'canaleAggLabel',
  COD_LEGGE = 'codLegge',
  COD_CARROZZERIA = 'codCarrozz',
  EURO = 'euro',
  TIPOLOGIA_SINISTRI = 'tipologiaSinistri',
  IMPRESA_DB_LABEL = 'impresaDbLabel',
  COD_IMP_CTP_LABEL = 'codImpCTPLabel',
  PLATE = 'targa',
  STATE = 'activity'
}
